// page-hero-band.js — canvas "network" overlay for the page hero band.
// Faithful vanilla-JS port of the live nanosoft canvasEffect: a fixed grid of
// points across the banner, each linked to its 5 nearest neighbours; the points
// drift gently around their origin and brighten around the cursor (the dots stay
// put — only the glow follows the mouse), exactly like assurex.co.

function distSq( a, b ) {
	return Math.pow( a.x - b.x, 2 ) + Math.pow( a.y - b.y, 2 );
}

// Circ.easeInOut (matches the live TweenLite easing).
function circEaseInOut( t ) {
	t *= 2;
	if ( t < 1 ) {
		return -0.5 * ( Math.sqrt( 1 - t * t ) - 1 );
	}
	t -= 2;
	return 0.5 * ( Math.sqrt( 1 - t * t ) + 1 );
}

function HeroNetwork( section ) {
	const holder = section.querySelector( '.ax-page-hero__particles' );
	if ( ! holder ) {
		return;
	}
	const canvas = document.createElement( 'canvas' );
	holder.appendChild( canvas );
	const ctx = canvas.getContext( '2d' );

	let width;
	let height;
	let points = [];
	const target = { x: 0, y: 0 };

	function build() {
		width = section.offsetWidth;
		height = section.offsetHeight;
		target.x = width / 2;
		target.y = height / 2;
		canvas.width = width;
		canvas.height = height;

		// 20 x 20 grid, each point jittered within its cell.
		points = [];
		for ( let x = 0; x < width; x += width / 20 ) {
			for ( let y = 0; y < height; y += height / 20 ) {
				const px = x + ( Math.random() * width ) / 20;
				const py = y + ( Math.random() * height ) / 20;
				points.push( { x: px, originX: px, y: py, originY: py } );
			}
		}

		// Link each point to its 5 closest neighbours.
		for ( let i = 0; i < points.length; i++ ) {
			const closest = [];
			const p1 = points[ i ];
			for ( let j = 0; j < points.length; j++ ) {
				const p2 = points[ j ];
				if ( p1 === p2 ) {
					continue;
				}
				let placed = false;
				for ( let k = 0; k < 5; k++ ) {
					if ( ! placed && closest[ k ] === undefined ) {
						closest[ k ] = p2;
						placed = true;
					}
				}
				for ( let k = 0; k < 5; k++ ) {
					if ( ! placed && distSq( p1, p2 ) < distSq( p1, closest[ k ] ) ) {
						closest[ k ] = p2;
						placed = true;
					}
				}
			}
			p1.closest = closest;
			p1.radius = 2 + Math.random() * 2;
			p1.active = 0;
			p1.circleActive = 0;
			shift( p1 );
		}
	}

	// Gentle drift: tween the point to a spot within ±50px of its origin, loop.
	function shift( p ) {
		p.sx = p.x;
		p.sy = p.y;
		p.tx = p.originX - 50 + Math.random() * 100;
		p.ty = p.originY - 50 + Math.random() * 100;
		p.t0 = performance.now();
		p.dur = ( 1 + Math.random() ) * 1000;
	}

	function animate( now ) {
		ctx.clearRect( 0, 0, width, height );
		for ( let i = 0; i < points.length; i++ ) {
			const p = points[ i ];

			// drift
			let e = ( now - p.t0 ) / p.dur;
			if ( e >= 1 ) {
				shift( p );
				e = 0;
			}
			const k = circEaseInOut( e );
			p.x = p.sx + ( p.tx - p.sx ) * k;
			p.y = p.sy + ( p.ty - p.sy ) * k;

			// brightness by distance to the cursor/centre
			const d = Math.abs( distSq( target, p ) );
			if ( d < 4000 ) {
				p.active = 0.3;
				p.circleActive = 0.6;
			} else if ( d < 20000 ) {
				p.active = 0.1;
				p.circleActive = 0.3;
			} else if ( d < 40000 ) {
				p.active = 0.02;
				p.circleActive = 0.1;
			} else {
				p.active = 0;
				p.circleActive = 0;
			}

			if ( p.active ) {
				for ( let c = 0; c < p.closest.length; c++ ) {
					const q = p.closest[ c ];
					if ( ! q ) {
						continue;
					}
					ctx.beginPath();
					ctx.moveTo( p.x, p.y );
					ctx.lineTo( q.x, q.y );
					ctx.strokeStyle = 'rgba(255,255,255,' + p.active + ')';
					ctx.stroke();
				}
			}
			if ( p.circleActive ) {
				ctx.beginPath();
				ctx.arc( p.x, p.y, p.radius, 0, 2 * Math.PI, false );
				ctx.fillStyle = 'rgba(255,255,255,' + p.circleActive + ')';
				ctx.fill();
			}
		}
		window.requestAnimationFrame( animate );
	}

	build();
	window.requestAnimationFrame( animate );

	if ( ! ( 'ontouchstart' in window ) ) {
		section.addEventListener( 'mousemove', ( ev ) => {
			const rect = section.getBoundingClientRect();
			target.x = ev.clientX - rect.left;
			target.y = ev.clientY - rect.top;
		} );
	}
	let resizeTimer;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( build, 200 );
	} );
}

const PageHeroBand = {
	onReady() {
		document.querySelectorAll( '.ax-page-hero' ).forEach( ( section ) => {
			if ( section.querySelector( '.ax-page-hero__particles' ) ) {
				HeroNetwork( section );
			}
		} );
	},
};

export default PageHeroBand;
